<template>
<div></div>
</template>

<script>
export default {
  name: "ThirdPartyLegalStatistics"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ThirdPartyLegalStatistics.vue